import { addQueryParam } from '@utils/add-query-param';

const tevoSiteUri = process.env.TICKET_EVO_BASE_URL;
const concatUri = (link: string) => tevoSiteUri + link;

export default {
  categories: concatUri('/categories'),
  category: (id: string) => `${concatUri('/categories')}/${id}`,
  eventsSearch: (queryObj: Record<string, unknown>) =>
    `${concatUri('/events/search')}?${addQueryParam(queryObj)}`,
  events: (queryObj: Record<string, unknown>) =>
    `${concatUri('/events')}?${addQueryParam(queryObj)}`,
  event: (id: number | string) => `${concatUri('/events')}/${id}`,
  performers: (name: number | string) => concatUri(`/performers/${name}`),
  venues: (name: number | string) => concatUri(`/venues/${name}`),
  performersSearch: (queryObj: Record<string, unknown>) =>
    `${concatUri('/performers/search')}?${addQueryParam(queryObj)}`,
  concat: (str: string) => `${concatUri(str)}`,
  search: (queryObj: Record<string, unknown>) =>
    `${concatUri('/search')}?${addQueryParam(queryObj)}`,
  orders: (queryObj: Record<string, unknown>) =>
    `${concatUri('/orders')}?${addQueryParam(queryObj)}`,
  configuration: (id: number) => `${concatUri('/configurations')}/${id}`,
  getEventProxy: (eventId: string | number, needTickets?: boolean) =>
    `/te/event?${addQueryParam({ eventId, needTickets })}`,
  listings: (
    event_id: string | number,
    lightweight?: false,
    type: string = 'event'
  ) =>
    concatUri(
      `/listings?${addQueryParam({
        event_id,
        lightweight,
        type,
      })}`
    ),
  createOrder: concatUri('/orders'),
  taxQuotes: concatUri('/tax_quotes'),
};
